"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BadMethodCallException_1 = __importDefault(require("./BadMethodCallException"));
class Exception extends Error {
    constructor(reason, previous) {
        if (reason.trim().length === 0) {
            throw new BadMethodCallException_1.default("Empty error message is not acceptable");
        }
        super(`${reason}${previous ? " - caused by " + previous.stack : ""}`);
        if (previous) {
            this.previous = previous;
        }
    }
}
exports.default = Exception;
//# sourceMappingURL=Exception.js.map